import { useEffect, useState } from 'react';
import { X } from '@/components/icons/barrel';

const TEXT_ANNOUNCEMENT = null;
const STORAGE_KEY = 'last-announcement';

const lastAnnouncement = localStorage.getItem(STORAGE_KEY);
const isInitialOpen = localStorage.getItem('announcement-open') !== 'false';

export default function AnnouncementBanner() {
  const [isOpen, setIsOpen] = useState(
    true,
    // isInitialOpen || TEXT_ANNOUNCEMENT !== lastAnnouncement,
  );

  useEffect(() => {
    if (!TEXT_ANNOUNCEMENT) return;
    localStorage.setItem(STORAGE_KEY, TEXT_ANNOUNCEMENT);
  }, []);

  useEffect(() => {
    localStorage.setItem('announcement-open', String(isOpen));
  }, [isOpen]);

  if (!isOpen || !TEXT_ANNOUNCEMENT) return;

  return (
    <div className="relative z-40 flex items-center justify-center border-b border-border bg-yellow px-6 py-1.5 text-black sm:px-8">
      <div className="flex-1">
        <p className="text-center text-sm tracking-wider">{TEXT_ANNOUNCEMENT}</p>
      </div>
      <button type="button" onClick={() => setIsOpen(false)}>
        <X size={14} />
      </button>
    </div>
  );
}
